const img = (n) => `/images/${n}.webp`;

export const momentScenes = [
  {
    id: "discover",
    tag: "Discover",
    title: "Discover a Moment.",
    body: "Garba under string lights, a set in the park, a rooftop supper. See what your people are sharing — and where you might belong tonight.",
    cta: "Browse moments",
    target: "feed",
    base: "moment-discover",
    alt: "Friends dancing garba together under strings of lights at night",
  },
  {
    id: "conversation",
    tag: "Connect",
    title: "Start a Conversation.",
    body: "A reply to a story becomes coffee on Saturday. Conversations begin with moments, not small talk.",
    cta: "See stories become chats",
    target: "stories",
    base: "moment-conversation",
    alt: "Two friends hugging hello at a sunlit cafe table",
  },
  {
    id: "memory",
    tag: "Remember",
    title: "Make a Memory.",
    body: "Plans become trips, trips become stories, and stories bring the next people together.",
    cta: "Get early access",
    target: "join",
    base: "moment-memory",
    alt: "A group of friends sharing chai on a hilltop at blue-hour sunset after a hike",
  },
];

export const trustPillars = [
  { id: "share", title: "Share On Your Terms", body: "Choose who sees your stories, moments and activities." },
  { id: "consent", title: "Connections By Consent", body: "New introductions require mutual acceptance before a private chat begins." },
  { id: "control", title: "AI Under Your Control", body: "Manage your AI's memory, recommendations and permissions." },
];

const friends = [
  { id: "shashin", name: "Shashin", avatar: img("avatar-shashin") },
  { id: "aditi", name: "Aditi", avatar: img("avatar-aditi") },
  { id: "aryan", name: "Aryan", avatar: img("avatar-aryan") },
  { id: "riya", name: "Riya", avatar: img("avatar-riya") },
  { id: "kabir", name: "Kabir" },
];
const discovery = [
  { id: "dev", name: "Dev", avatar: img("avatar-dev"), ai: true },
  { id: "meera", name: "Meera", avatar: img("avatar-meera"), ai: true },
  { id: "aarav", name: "Aarav", avatar: img("avatar-aarav"), ai: true },
];

export const privacyOptions = [
  {
    id: "only-me", label: "Only Me", audience: [], count: "Just you",
    explain: "Your story stays private. Nobody else can see it.",
  },
  {
    id: "selected", label: "Selected Friends", audience: friends.slice(0, 2), count: "2 friends selected · Shashin, Aditi",
    explain: "Only the friends you pick will see this moment.",
  },
  {
    id: "all", label: "All Friends", audience: friends, count: "5 friends",
    explain: "Everyone you're connected with can see and reply.",
  },
  {
    id: "discovery", label: "Opt-in Discovery", audience: [...friends, ...discovery], count: "5 friends + 3 people with matching interests",
    explain: "Your friends, plus people who also opted into discovery and share your interests. They only see moments you mark as discoverable.",
    ai: true,
  },
];

export const footerLinks = [
  { id: "experience", label: "Experience" },
  { id: "stories", label: "Stories" },
  { id: "connections", label: "Connections" },
  { id: "personal-ai", label: "Personal AI" },
  { id: "join", label: "Join Waitlist" },
];

export const CONTACT_EMAIL = "karna.desai.world@gmail.com";
